import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";


declare var ko: any;

export class transactionsPaymentSummary_template extends vnTemplate{

    public validationsList: validationsList_template;

    protected getTemplateHtml(): string{

        return `
            <div class="sub-header w-justify">
                <div class="w-left">
                    <div>
                        <label for="idPayment" class="form-label form-label-box">Payment Date</label>
                        <select id="idPayment" data-bind="options: payments, optionsText: 'name', value: idPayment, optionsCaption: 'Select', optionsValue: 'id', valueAllowUnset: true,event: { change: onChangeFilterAction }">
                    </select>
                    </div>
                </div>
                <div class="w-center">
                    ` + this.validationsList.getHtmlBuild() + `
                   
                </div>
                <div class="w-right">
                     <button class="btn secondary icon i-export" type="button" data-bind="event: { click: onClickExportCAD }, visible: isPrintVisible">Export CAD</button>
                     <button class="btn secondary icon i-export" type="button" data-bind="event: { click: onClickExportUSD }, visible: isPrintVisible">Export USD</button>

                </div>
            </div>
            
            <div class="list-header">
                ` + this.validationsList.getHtmlBuild() + `
            </div>
            
            <div class="w-list-results"  id="list-results">
                <table class="list-results">
                     <thead>
                     <tr>
                            <th><span></span></th>
                            <th><span>user</span></th>
                            <th><span>Payment Method</span></th>
                            <th><span>Payment Method ID</span></th>
                            <th><span>currency</span></th>
                            <th class="align-right"><span>total paid</span></th>
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: users">
                        <tr>
                            <td class="details button"><button data-bind="event: { click: $parent.onClickDetails }, css: { 'is-open' : showDetails }" type="button" class="btn border small only-icon icon i-dropdown-simple"></button></td>
                            <td class="user_fullName"><span data-bind="text: user_fullName"></span></td>
                            <td class="paymentEmail"><span data-bind="text: paymentMethod"></span></td>
                            <td class="paymentEmail"><span data-bind="text: paymentEmail"></span></td>
                            <td class="currency"><span data-bind="text: currency"></span></td>
                            <td class="total align-right"><span data-bind="text: total"></span></td>
                        </tr>
                        <tr class="w-child-results">
                            <td colspan="5">
                                <div data-bind="css: { 'is-open' : showDetails }" class="w-list-child">
                                    <table class="child-results">
                                        <!--<thead>
                                            <tr>
                                                <th><span>name</span></th>
                                                <th><span>amount</span></th>
                                            </tr>
                                        </thead>-->
                                        <tbody data-bind="foreach: transactions">
                                            <tr>
                                                <td class="left-align"><span data-bind="text: entry_type"></span></td>
                                                <td class="left-align"><span data-bind="text: project_name"></span></td>
                                                <td class="left-align"><span data-bind="text: dateCreation"></span></td>
                                                <td class="amount align-right"><span data-bind="text: amount"></span></td>
                                            </tr>
                                        </tbody>
                                    </table>    
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            `;
    }

    protected initPartial(): void {
        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this.caller);
    }

    public setUsers(users){
        this.getTemplateViewModel().users(users);
    }

    public setPayments(payments){
        this.getTemplateViewModel().payments(payments);
    }


    protected getTemplateName(): string{
        return "transactionsPaymentSummary-template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected getMainElementClasses(): Array<string>{
        return [""];
    }

    protected buildViewModel(): any{

        // define the viewmodel data/ functions
        let huit_neuf_this = this;
        return  {
            users: ko.observableArray([])
            ,idPayment: ko.observable("")
            ,payments: ko.observable([])
            ,isPrintVisible: ko.observable(false)
            ,onChangeFilterAction: function (data, event) { huit_neuf_this.onChangeFilterAction(data); }
            ,onClickDetails: function(data,event){ huit_neuf_this.onClickDetails(data); }
            ,onClickPrint: function(data,event){ huit_neuf_this.onClickPrint(data); }
            ,onClickExportCAD: function (data, event) { huit_neuf_this.onClickExportCAD(data); }
            ,onClickExportUSD: function (data, event) { huit_neuf_this.onClickExportUSD(data); }
        };
    }

    public onChangeFilterAction(data) {

        if (data.idPayment() != null){
            this.getTemplateViewModel().isPrintVisible(true);
        }
        else{
            this.getTemplateViewModel().isPrintVisible(false);
        }
        this.caller.filterSimpleOnChange();
    }

    public onClickExportCAD(data){
        this.caller.exportCADToCSV(data.users());
    }

    public onClickExportUSD(data){
        this.caller.exportUSDToCSV(data.users());
    }

    public onClickDetails(data) {
        if (data.showDetails){
            data.showDetails = false;
            data.transactions = [];
            //force refresh - if you don't do this the foreach HTML will not be updated.
            var tmp = this.getTemplateViewModel().users();
            this.getTemplateViewModel().users([]);
            this.getTemplateViewModel().users(tmp);
        }
        else{
            data.showDetails = true;
            this.caller.getUserPaymentDetails(data.user_id);
        }
    }

    public onClickPrint(data) {
        var idPayment = data.idPayment();
        this.caller.showPrintView(idPayment);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/transactionsPaymentSummary_template.ts